import type { Member } from '@/features/iam/members/Member'
import type {
  GetCurrentMemberFn,
  GetCurrentUserWorkspaceMembershipsFn,
  GetTeamMembersForWorkspaceMemberFn,
} from '@/features/iam'

/**
 * Gets the current user's members in the workspaces where they can create
 * jobs, either at the workspace or at the team level.
 */
export type GetDraftingMembersFn = () => Member[]

/** @see GetDraftingMembersFn */
export function createGetDraftingMembersFn(
  getCurrentUserWorkspaceMemberships: GetCurrentUserWorkspaceMembershipsFn,
  getTeamMembersForWorkspaceMember: GetTeamMembersForWorkspaceMemberFn,
  getCurrentMember: GetCurrentMemberFn,
): GetDraftingMembersFn {
  return () =>
    getCurrentUserWorkspaceMemberships()
      .filter(
        ({ member, workspace }) =>
          member.permissions.startNewJob ||
          member.permissions.adminJobCreate ||
          getTeamMembersForWorkspaceMember(
            workspace.id,
            getCurrentMember().user.id,
          ).some(
            (tm) =>
              tm.permissions.createTeamJobs || tm.permissions.startTeamJobs,
          ),
      )
      .map((m) => m.member)
}
